export function getUrl(){

    let url = window.location.href;
    let baseUrl = "//pro.mimic.us/";

    if(url.indexOf("secondev")!== -1 || url.indexOf("localhost")!== -1) {
        // 개발환경
    } else {
        // real
        baseUrl = "//pro.mimic.us/";
    }

    return baseUrl;
}



// WEBPACK FOOTER //
// ./src/lib/requestLib.js